var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultimediaButtonCircle = function SvgMultimediaButtonCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.588a8.512 8.512 0 1 1 0 17.023 8.512 8.512 0 0 1 0-17.023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.686 7.514C6.822 6.508 7.707 5.94 8.65 6.317c.593.236 1.373.59 2.374 1.123.947.503 1.694.953 2.275 1.333 1.026.674 1.026 1.98 0 2.654-.58.38-1.328.83-2.275 1.333a24 24 0 0 1-2.374 1.124c-.943.375-1.828-.192-1.964-1.197a19 19 0 0 1-.168-2.587c0-1.033.076-1.905.168-2.586"
  }))));
};
export default SvgMultimediaButtonCircle;